import type { KnowledgeHit } from "./technical-knowledge.js";
import type { ReviewFacts, ReviewField } from "./technical-rules.js";

/**
 * AIProvider — o INSPECT IA não fica acoplado a um fornecedor.
 *
 *   review()  findings estruturados de um conjunto de campos
 *   chat()    resposta do assistente ancorada nos trechos recuperados
 *   embed()   ponto de extensão para busca vetorial futura (opcional)
 *
 * A saída de `review()` é tratada como NÃO CONFIÁVEL: passa por
 * `validateFindingsOutput` antes de virar finding, seja qual for o provedor.
 */
export interface AIReviewRequest {
  readonly subjectLabel: string;
  readonly fields: readonly ReviewField[];
  readonly facts: ReviewFacts;
  /** Documentos da Base Técnica (códigos) — para não acusar como "não declarada" uma norma cadastrada. */
  readonly knowledgeDocuments: readonly string[];
  readonly promptVersion: string;
}

export interface AIChatRequest {
  readonly question: string;
  readonly subjectLabel: string | null;
  readonly fields: readonly ReviewField[];
  readonly facts: ReviewFacts | null;
  readonly modulePendencies: readonly string[];
  readonly knowledge: readonly KnowledgeHit[];
  readonly promptVersion: string;
}

export interface AIChatAnswer {
  readonly text: string;
  readonly sourceRefs: ReadonlyArray<{ readonly document: string; readonly revision: string; readonly section: string; readonly entryId: string | null }>;
  /** Texto proposto para um campo — só entra no relatório com confirmação ("APLICAR AO CAMPO"). */
  readonly fieldSuggestion: { readonly fieldPath: string; readonly label: string; readonly text: string; readonly baseText: string } | null;
  readonly grounded: boolean;
}

export interface AIProvider {
  readonly id: string;
  readonly model: string;
  readonly modelVersion: string;
  isAvailable(): Promise<boolean>;
  /** Resposta crua — validada pelo orquestrador. */
  review(request: AIReviewRequest): Promise<unknown>;
  chat(request: AIChatRequest): Promise<AIChatAnswer>;
  embed?(texts: readonly string[]): Promise<number[][]>;
}

export class AIProviderUnavailableError extends Error {
  constructor(message = "Serviço INSPECT IA REVIEW temporariamente indisponível.") {
    super(message);
    this.name = "AIProviderUnavailableError";
  }
}
